export default __webpack_public_path__ + "static/media/breadcrumb-logo-color.306d3ba6.svg";